<template>
    <b-container fluid>
        <app-supervision-activity-header
            >Revisión Herramientas</app-supervision-activity-header
        >
        <b-row v-if="tools.length === 0">
            <b-col>
                <b-alert show variant="info"
                    >No hay herramientas para el cliente</b-alert
                >
            </b-col>
        </b-row>
        <b-row v-for="(tool, i) in tools" :key="tool.id" v-else class="mb-2">
            <b-col>
                <app-supervision-tool-revision-item
                    @change="onChangeAnswer"
                    :item="tool"
                    :statuses="toolStatuses"
                    :itemIndex="parseInt(i) + 1"
                />
            </b-col>
        </b-row>
        <b-row class="justify-content-end">
            <b-col cols="12" md="4" lg="3">
                <b-btn variant="confirm" block @click="saveAnswers"
                    >Guardar Respuestas</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import clientsRepository from "../../../repositories/clients.repository";
import SupervisionToolRevisionItem from "./SupervisionToolRevisionItem";
import SupervisionActivityHeader from "../SupervisionActivityHeader";
import supervisionRepository from "../../../repositories/supervision.repository";
export default {
    components: {
        appSupervisionToolRevisionItem: SupervisionToolRevisionItem,
        appSupervisionActivityHeader: SupervisionActivityHeader
    },
    data: () => ({
        tools: [],
        toolStatuses: [],
        answers: []
    }),
    computed: {
        ...mapGetters(["supervisionClient"])
    },
    methods: {
        async loadTools() {
            const cr = { ...clientsRepository };
            const { data } = await cr.loadTools(this.supervisionClient.id);
            this.tools = data;
        },
        async loadToolStatuses() {
            const cr = { ...clientsRepository };
            const { data } = await cr.loadToolStatuses();
            this.toolStatuses = data;
        },
        onChangeAnswer(answer) {
            const answers = this.answers.filter(
                item => item.tool !== answer.tool
            );
            answers.push(answer);
            this.answers = answers;
        },
        async saveAnswers() {
            if (!this.validAnswers()) {
                return;
            }

            try {
                const toolStatuses = this.answers.map(item => ({
                    toolId: item.tool,
                    statusId: item.status.id,
                    reference: item.reference,
                    notes: item.notes
                }));

                const sr = { ...supervisionRepository };

                const data = await sr.saveToolsReview(
                    this.supervisionClient.id,
                    this.user.id,
                    0,
                    toolStatuses
                );

                toastr.success("Respuestas registradas");
                this.$router.push({ name: "supervisionIndexPage" });
            } catch (err) {
                this.handleErrors(err);
            } finally {
            }
        },
        validAnswers() {
            if (this.answers.length < this.tools.length) {
                toastr.error("Debe contestar todas las preguntas");
                return false;
            }

            const errors = this.answers.filter(
                a =>
                    !a.status ||
                    !a.reference ||
                    (!!a.status.require_notes && a.notes.length === 0)
            );
            if (!!errors.length) {
                toastr.error("Debe diligenciar todas las herramientas");
                return false;
            }

            return true;
        }
    },
    created() {
        this.loadTools();
        this.loadToolStatuses();
    }
};
</script>
